export function formatSalonLabel(salon) {
  if (!salon) {
    return "";
  }

  const id = salon.id ?? salon.salon_id ?? salon.salonId;
  const name = salon.name ?? salon.salon_name ?? salon.salonName ?? "";

  if (name && id != null) {
    return `${name} - Salon ID ${id}`;
  }
  if (name) {
    return name;
  }
  if (id != null) {
    return `Salon ID ${id}`;
  }
  return "";
}
